export function openModal(id) {
  const modalEl = document.getElementById(id)
  if (modalEl && Alpine.$data(modalEl)) {
    Alpine.$data(modalEl).open = true
  }
}
